"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_1 = require("@ethersproject/bignumber");
const base_1 = require("../base");
const util_1 = require("../util");
class OrderModule extends base_1.TectonicSDKModule {
    constructor() {
        super(...arguments);
        /**
         * @notice Create a long and short position. Suppose long token A and short token B.
         * @param tectonicSocketAddress       Address of tectonic socket
         * @param longAmount                  Amount of token A to long
         * @param shortAmount                 Amount of token B to short
         * @param slippageTolerance           User's selected slippage tolerance for swap
         * @param dexes                       DEXes to perform swaps
         * @param paths                       Paths to swap token on DEXes, underlyingTokenToShort swap to underlyingTokenToLong
         * @param isLongCRO                   Whether the long token is CRO, if use native token, should pass the value to the SC
         */
        this.createLongNShortPosition = async (tectonicSocketAddress, longAmount, shortAmount, slippageTolerance, dexes, paths, isLongCRO) => {
            const sdk = this.getSdkBase();
            const deferLiquidityCheckAdapter = sdk.getDeferLiquidityCheckAdapter();
            const [_, amountOutMin] = await sdk.getTTokenAmountOut(tectonicSocketAddress, shortAmount, slippageTolerance, paths[0]);
            return (0, util_1.wrapSdkTransaction)(deferLiquidityCheckAdapter.createLongNShortPosition(tectonicSocketAddress, longAmount, shortAmount, amountOutMin, dexes, paths, { value: isLongCRO ? longAmount : bignumber_1.BigNumber.from(0) }));
        };
        /**
         * @notice Create a long and short position. Suppose long token A and short token B.
         * @param tectonicSocketAddress       Address of tectonic socket
         * @param longAmount                  Amount of token A to long
         * @param shortAmount                 Amount of token B to short
         * @param longToken                   Token to long
         * @param shortToken                  Token to short
         * @param swapData                    Txn data of WOWMAX, need call WOWMAX api to get
         * @param isLongCRO                   Whether the long token is CRO, if use native token, should pass the value to the SC
         */
        this.createLongNShortPositionByWowmax = async (tectonicSocketAddress, longAmount, shortAmount, longToken, shortToken, swapData, isLongCRO) => {
            const sdk = this.getSdkBase();
            const deferLiquidityCheckAdapter = sdk.getDeferLiquidityCheckAdapter();
            return (0, util_1.wrapSdkTransaction)(deferLiquidityCheckAdapter.createLongNShortPositionByWowmax(tectonicSocketAddress, longAmount, shortAmount, longToken, shortToken, swapData, { value: isLongCRO ? longAmount : bignumber_1.BigNumber.from(0) }));
        };
    }
    getSdkBase() {
        return this;
    }
}
exports.default = OrderModule;
//# sourceMappingURL=order.js.map